// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f8e0f85","453":"21b126ce","732":"251711f3","977":"9e716258"}[chunkId] + ".chunk.js";
};